import React from "react";

import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { ChangeEvent } from "utils/history/Event";
import { MultiSelectField } from "../FieldService";
import SelectAttachment from "./SelectAttachment";

export type MultiSelectInputProps = {
	field: MultiSelectField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const MultiSelectInput: React.FC<MultiSelectInputProps> = (
	props: MultiSelectInputProps
) => {
	const selectedOptions = props.field.options.filter(option =>
		props.field.value.includes(option.value)
	);

	function isValid(value: string): boolean {
		return props.field.required
			? props.field.options.some(option => option.value === value)
			: true;
	}

	function onChange(newValue: string): void {
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, isValid(newValue));
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			{/* TODO: checkboxes next to each other */}
			<Grid item xs={12} sm={6}>
				{props.editable &&
				props.rights[props.field.uuid][InformationRight.WRITE] ? (
					<TextField
						id={props.field.name}
						select
						fullWidth
						required={props.field.required}
						error={!isValid(props.field.value[0])}
						value={props.field.value ?? []}
						onChange={event => onChange(event.target.value)}
						SelectProps={{ multiple: true }}
						variant="standard">
						<MenuItem value="">
							<p style={{ margin: 12 }} />
						</MenuItem>
						{props.field.options?.map((option, index) => (
							<MenuItem key={index} value={option.value}>
								{option.value}
							</MenuItem>
						))}
					</TextField>
				) : (
					<Typography variant="body2" sx={{ wordWrap: "break-word" }}>
						{props.field.value.join(", ")}
					</Typography>
				)}
			</Grid>
			<Grid item container direction="column">
				{selectedOptions
					.flatMap(option => option.attachments)
					.map((attachment, index) => (
						<Grid item key={`${attachment}-${index}`}>
							<SelectAttachment id={attachment} />
						</Grid>
					))}
			</Grid>
		</Grid>
	);
};

export default MultiSelectInput;
